import { clsx } from "clsx";
import type { MpzpOrder } from "../../types";
import { fmtDateTime } from "../../utils";

// Utworzono → (Opłata) → Wysłano → Otrzymano → Zakończono. Kroki opłaty pojawiają się
// dopiero, gdy opłata istnieje — kwotę wylicza gmina, więc bywa, że dochodzi po wysyłce.
// Wypis pozyskany ręcznie poza ELGW5 nie ma wniosku ani wysyłki: rodzi się „otrzymany",
// więc jego oś to tylko pozyskanie i zakończenie.
export function MpzpTimeline({ order }: { order: MpzpOrder }) {
  const steps: { label: string; at: string | null; done: boolean }[] = order.obtained_manually
    ? [
        { label: "Pozyskany ręcznie poza ELGW5", at: order.received_at ?? order.created_at, done: true },
        { label: "Zakończono", at: null, done: order.status === "completed" },
      ]
    : [
    { label: "Utworzono", at: order.created_at, done: true },
    ...(order.fee_id
      ? [
          {
            label: "Prośba o opłatę",
            at: null,
            done:
              ["fee_requested", "fee_paid", "sent", "received", "completed"].includes(order.status) ||
              !!order.fee_status,
          },
          {
            label: "Opłacona",
            at: null,
            done:
              order.fee_status === "payment_uploaded" ||
              order.fee_status === "acknowledged" ||
              ["sent", "received", "completed"].includes(order.status),
          },
        ]
      : []),
    { label: "Wysłano do gminy", at: order.sent_at, done: !!order.sent_at },
    { label: "Wypis i wyrys otrzymany", at: order.received_at, done: !!order.received_at },
    { label: "Zakończono", at: null, done: order.status === "completed" },
  ];
  return (
    <div className="flex flex-wrap items-center gap-2">
      {steps.map((step, i) => (
        <div key={step.label} className="flex items-center gap-2">
          {i > 0 && <div className="w-6 h-px bg-[var(--color-border-strong)]" />}
          <div
            className={clsx(
              "px-2 py-1 text-[11px] font-mono uppercase tracking-wide border",
              step.done
                ? "bg-green-50 text-green-800 border-green-300"
                : "bg-[var(--color-bg-elevated)] text-[var(--color-text-muted)] border-[var(--color-border)]",
            )}
            title={step.at ? fmtDateTime(step.at) : undefined}
          >
            {step.label}
          </div>
        </div>
      ))}
    </div>
  );
}
